import angular from 'angular';

import LanguageComponent from './language.component';

export default angular.module('language', [])
    .component('languageComponent', LanguageComponent)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/language/language.module.js
// module id = 347
// module chunks = 0